import React from 'react';
import { Footer, Header } from '../Common';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { AffiliatorDashboardHeader } from '../Common/AffiliatorDashboardHeader';
class AffiliatorProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
            firstName:'',
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    render() {
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4 input_name">
                                    <AffiliatorSidebar />
                                </div>
                                <div className="col-md-8">
                                    <div className="mt-5 mb-3 input_name big_font guide_text">
                                        Affiliator Profile
                                    </div>
                                    <form>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">First Name</label>
                                                    <span className="mandatory_alert">* </span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" value={this.state.firstName} onChange={this.updateValue.bind(this,'firstName')}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Last Name</label>
                                                    <span className="mandatory_alert">* </span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" value={this.state.lastName} onChange={this.updateValue.bind(this,'lastName')} />
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Phonetic </label>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" value={this.state.phonetic} />
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Gender</label>
                                                    <span className="mandatory_alert">* </span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                                                        <label className="form-check-label" htmlFor="inlineRadio1">Male</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                                                        <label className="form-check-label" htmlFor="inlineRadio2">Female</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Company name</label>
                                                    <span className="mandatory_alert">* </span>
                                                    {/* <span ><i className="fas fa-star"></i></span> */}
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Department in charge </label>
                                                    <span className="mandatory_alert">* </span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Postal code</label>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="number" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Referral code</label>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="number" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Prefectures</label>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div> */}
                                        {/* <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">City</label>
                                                    <span className="mandatory_alert">* </span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Address</label>
                                                    <span className="mandatory_alert">* </span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Phone Number</label>
                                                    <span className="mandatory_alert">* </span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="number" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Fax Number</label>
                                                    <span className="mandatory_alert">* </span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="number" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Password</label>
                                                    <span className="mandatory_alert">* </span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="password" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Confirm Password</label>
                                                    <span className="mandatory_alert">* </span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="password" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Email Address</label>
                                                    <span className="mandatory_alert">* </span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="email" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Confirm Email</label>
                                                    <span className="mandatory_alert">* </span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="email" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">WEB site URL</label>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">WEB BLOG URL</label>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Mail magazine URL </label>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-5 mb-3 input_name big_font guide_text">
                                            *** Financial Information ***
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Financial Institute Name</label>
                                                    <span className="mandatory_alert">* Required</span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Transfer destination branch name </label>
                                                    <span className="mandatory_alert">* Required</span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Transferee deposit items</label>
                                                    <span className="mandatory_alert">* Required</span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                                                        <label className="form-check-label" htmlFor="inlineRadio1">Usually</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                                                        <label className="form-check-label" htmlFor="inlineRadio2">Current</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Transfer destination account number</label>
                                                    <span className="mandatory_alert">* Required</span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Transferee Account Name</label>
                                                    <span className="mandatory_alert">* Required</span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <label htmlFor="exampleInputEmail1" className="mt-1">Attention about input</label>
                                                    <span className="mandatory_alert">* Required</span>
                                                </div>
                                                <div className="col-md-1 mt-1">:</div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control input_form" aria-label="Default" aria-describedby="inputGroup-sizing-default" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-center p-3 mt-3" >
                                            <button type="submit" className="btn btn-lg btn-success " >
                                                <span className="fa fa-check"></span>
                                                Confirm Change
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
export { AffiliatorProfile }